import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { Link, navigate } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getShopifyImage } from 'gatsby-source-shopify'
import debounce from 'lodash.debounce'
import { SearchProvider } from '../../../context/search-provider'
import { StoreContext } from '../../../context/store-context'
import CrossIcon from '../../../icons/cross'
import SearchGlassIcon from '../../../icons/search-glass'
import { useOutsideAlerter, useSearch } from '../../../utils/hooks'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import {
  active,
  no_suggestions,
  search_bar,
  search_bar_wrapper,
  search_input,
  search_more,
  search_suggestions,
  suggestionImageStyle,
} from './search-bar.module.scss'

function SearchNav(props) {
  return (
    <SearchProvider>
      <SearchNavComponent {...props} />
    </SearchProvider>
  )
}

function SearchNavComponent() {
  const { hiddenIds } = React.useContext(StoreContext)
  const [showSuggestions, setShowSuggestions] = useState('')
  const [pause, setPause] = useState(true)
  const [search, setSearch] = useState('')
  const [query, setQuery] = useState('')
  const [seachSize, setSearchSize] = useState(8)
  useEffect(() => {
    if (window.innerHeight <= 991) {
      setSearchSize(6)
    }
  }, [])

  const wrapperRef = useRef(null)

  useOutsideAlerter(wrapperRef, () => setShowSuggestions(false))

  const handleSearch = async (query) => {
    if (query && query.length > 0) {
      setQuery(query)
      setShowSuggestions(true)
      setPause(false)
    }
  }
  const debouncedHandler = useCallback(debounce(handleSearch, 1000), [])

  const onKeyDown = (key) => {
    if (key.key === 'Enter' || key.key === 'Tab') {
      setShowSuggestions(false)
    }
  }

  const { products, isFetching } = useSearch(query, pause, seachSize)

  if (!pause && !isFetching && products && products.length > 0) {
    setPause(true)
  }

  const submit = (event) => {
    event.preventDefault()
    if (search && search.length > 0) {
      navigate(`/search?q=${search}&s=TITLE`)
    }
  }

  return (
    <Form onSubmit={submit} ref={wrapperRef}>
      <Form.Group
        className={`position-relative ${search_bar_wrapper} ${
          showSuggestions && search.length >= 3 && active
        }`}
      >
        <div
          className={`w-100 d-flex align-items-center mx-4 my-2 p-0 ${search_bar} ${
            showSuggestions && search.length >= 3 && active
          }`}
        >
          <Form.Label hidden>Search</Form.Label>
          <Form.Control
            className={`${search_input}`}
            type='text'
            value={search}
            placeholder='Search'
            onChange={(event) => {
              debouncedHandler(event.target.value)
              setSearch(event.target.value)
            }}
            onKeyDown={onKeyDown}
            onFocus={() => {
              setShowSuggestions(true)
            }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          />
          {search.length >= 3 && (
            <button
              type='reset'
              onClick={() => {
                setQuery('')
                setSearch('')
                // setFilters((filters) => ({ ...filters, term: "" }))
              }}
              aria-label='Clear search query'
            >
              <CrossIcon className='search-bar cross-icon' />
            </button>
          )}
        </div>
        {showSuggestions && search.length >= 3 && (
          <div className={search_suggestions}>
            <ContentContainer className='px-4'>
              {isFetching && (
                <div className={no_suggestions}>
                  <em>Loading</em>
                </div>
              )}
              {products && products.length > 0 && (
                <>
                  {products
                    .filter((product) => hiddenIds.indexOf(product.id) < 0)
                    .slice(0, 3)
                    .map((node, index) => {
                      let storefrontImageData = {}
                      const storefrontImage = node.images.edges[0].node
                      try {
                        storefrontImageData = getShopifyImage({
                          image: storefrontImage,
                          layout: 'constrained',
                          width: 100,
                          height: 80,
                        })
                      } catch (e) {
                        console.error(e)
                      }
                      return (
                        <React.Fragment key={node.handle}>
                          <Row className='my-2'>
                            <Col xs={3} sm={3}>
                              {storefrontImage != null ? (
                                <div className={suggestionImageStyle}>
                                  <GatsbyImage
                                    alt={node.title}
                                    image={storefrontImageData}
                                    loading={index === 0 ? 'eager' : 'lazy'}
                                  />
                                </div>
                              ) : (
                                <div />
                              )}
                            </Col>
                            <Col
                              xs={9}
                              sm={9}
                              className='d-flex align-items-center'
                            >
                              <Link to={`/products/${node.handle}`}>
                                {node.title}
                              </Link>
                            </Col>
                          </Row>
                          <hr />
                        </React.Fragment>
                      )
                    })}

                  <Row key={-1} className='my-2 py-2'>
                    <Col xs={12} className={search_more}>
                      <Link
                        className='d-flex '
                        to={`/search?q=${search}&s=TITLE`}
                      >
                        <SearchGlassIcon className='d-inline' />
                        <h5 className='d-inline mx-2'>See More Results</h5>
                      </Link>
                    </Col>
                  </Row>
                </>
              )}
              {isFetching ||
                products == null ||
                (products.length == 0 && (
                  <div className={no_suggestions}>
                    <em>No suggestions, you&apos;re on your own!</em>
                  </div>
                ))}
            </ContentContainer>
          </div>
        )}
      </Form.Group>
      <Button hidden variant='primary' type='submit'>
        Submit
      </Button>
    </Form>
  )
}

export default SearchNav
